import { ReactNode, useState } from "react";
import { AuthContext, AuthContextType } from "../context/AuthContext";

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [token, setToken] = useState<string | null>(null);
    const [roles, setRoles] = useState<any[]>([]);
    const [user, setUser] = useState<any>();

    const contextValue: AuthContextType = {
        isAuthenticated,
        user,
        setIsAuthenticated,
        setUser,
        token: token,
        roles: roles,
        setToken: setToken,
        setRoles: setRoles,
    };

    return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};
